/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: MPL-2.0
 */

import { useFormContext } from 'react-hook-form'
import Select from '@hashicorp/react-mds/src/hds/components/form/select'
import FieldWrapper from '../../field-wrapper'
import { formattedLabel, useErrorMessage } from '../../../utils'
import type { MarketoFormSelectField } from '../../../types'
import s from './style.module.css'

const SelectField = ({ field }: { field: MarketoFormSelectField }) => {
	const { register } = useFormContext()
	const error = useErrorMessage(field.id)

	return (
		<FieldWrapper fieldId={field.id}>
			<Select
				field={{ ...register(field.id) }}
				size="large"
				label={formattedLabel(field)}
				error={error}
				isRequired={field.required}
				className={s.selectConstrainWidth}
			>
				{field.fieldMetaData.values
					? field.fieldMetaData.values.map(({ label, value }) => (
							<option key={label} value={value}>
								{label}
							</option>
					  ))
					: []}
			</Select>
		</FieldWrapper>
	)
}

export default SelectField
